import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';

interface TotalCardProps {
    title: string;
    value: number | string;
    icon?: React.ReactNode;
    titleContainerStyles?: SxProps<Theme>;
    containerStyles?: SxProps<Theme>;
    labelTypographyStyles?: SxProps<Theme>;
    valueTypographyStyles?: SxProps<Theme>;
}

export const TotalCard: React.FC<TotalCardProps> = ({
    title,
    value,
    icon,
    titleContainerStyles,
    containerStyles,
    labelTypographyStyles,
    valueTypographyStyles,
}) => {
    return (
        <Box
            sx={{
                border: '1px solid #FEE380',
                borderRadius: '8px',
                borderColor: '#FEE380',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                ...containerStyles,
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{
                    backgroundColor: '#F39E4E',
                    padding: '8px 16px',
                    borderRadius: '8px 8px 0 0',
                    ...titleContainerStyles,
                }}
                gap={2}
            >
                {icon}
                <Typography
                    fontSize="24px"
                    fontWeight={500}
                    color="#FFFCF0"
                    textAlign="center"
                    sx={labelTypographyStyles}
                >
                    {title}
                </Typography>
            </Stack>
            <Typography
                fontSize="24px"
                color="#575757"
                textAlign="center"
                my="16px"
                sx={valueTypographyStyles}
            >
                {value}
            </Typography>
        </Box>
    );
};
